import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceOverview = () => {
  const services = [
    {
      id: 1,
      icon: 'Share2',
      title: 'Social Media Marketing',
      description: 'Strategic social media campaigns that build communities, drive engagement, and convert followers into loyal customers.',
      features: ['Content Strategy', 'Community Management', 'Paid Advertising', 'Analytics & Reporting'],
      color: 'from-blue-500 to-cyan-500',
      stats: { metric: 'Avg. Engagement Increase', value: '340%' }
    },
    {
      id: 2,
      icon: 'Code',
      title: 'Web Development',
      description: 'Custom websites and web applications built with modern technologies, optimized for performance and user experience.',
      features: ['Responsive Design', 'Performance Optimization', 'SEO Integration', 'CMS Solutions'],
      color: 'from-purple-500 to-pink-500',
      stats: { metric: 'Avg. Load Time Improvement', value: '65%' }
    },
    {
      id: 3,
      icon: 'Smartphone',
      title: 'App Development',
      description: 'Native and cross-platform mobile applications that deliver exceptional user experiences and drive business growth.',
      features: ['iOS & Android', 'Cross-Platform', 'UI/UX Design', 'App Store Optimization'],
      color: 'from-green-500 to-emerald-500',
      stats: { metric: 'Avg. User Retention', value: '85%' }
    }
  ];

  return (
    <section className="py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="Target" size={16} />
            <span>Our Core Services</span>
          </div>
          <h2 className="text-3xl lg:text-5xl font-bold text-foreground mb-6">
            Three Pillars of Digital Excellence
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Each service is designed to work independently or as part of a comprehensive digital strategy, 
            delivering measurable results that drive your business forward.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid lg:grid-cols-3 gap-8">
          {services?.map((service) => (
            <div 
              key={service?.id}
              className="group bg-card rounded-2xl p-8 brand-shadow hover:shadow-xl brand-transition brand-hover-lift"
            >
              {/* Service Icon */}
              <div className={`w-16 h-16 bg-gradient-to-r ${service?.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 brand-transition`}>
                <Icon name={service?.icon} size={32} className="text-white" />
              </div>

              {/* Service Content */}
              <h3 className="text-2xl font-bold text-foreground mb-4">{service?.title}</h3>
              <p className="text-muted-foreground mb-6 leading-relaxed">{service?.description}</p>

              {/* Features List */}
              <div className="space-y-3 mb-8">
                {service?.features?.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-accent rounded-full"></div>
                    <span className="text-foreground font-medium">{feature}</span>
                  </div>
                ))}
              </div>

              {/* Stats */}
              <div className="border-t border-border pt-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-muted-foreground">{service?.stats?.metric}</p>
                    <p className="text-2xl font-bold text-accent">{service?.stats?.value}</p>
                  </div>
                  <Icon name="TrendingUp" size={24} className="text-success" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 lg:p-12">
            <h3 className="text-2xl lg:text-3xl font-bold text-white mb-4">
              Ready to Transform Your Digital Presence?
            </h3>
            <p className="text-white/90 mb-8 max-w-2xl mx-auto">
              Let's discuss how our comprehensive services can work together to achieve your business goals.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-accent hover:bg-accent/90 text-accent-foreground px-8 py-3 rounded-lg font-semibold brand-transition brand-hover-lift flex items-center justify-center space-x-2">
                <Icon name="MessageCircle" size={20} />
                <span>Start Conversation</span>
              </button>
              <button className="border border-white/30 text-white hover:bg-white/10 px-8 py-3 rounded-lg font-semibold brand-transition flex items-center justify-center space-x-2">
                <Icon name="Download" size={20} />
                <span>Download Brochure</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceOverview;